import { Configuration } from '@rbx/clients';
import { getBEDEV1ServiceBasePath } from '@modules/utilities/constants/baseUrl';

import {
  MembershipApi,
  RobloxGroupsApiGroupMembershipMetadataResponse,
  V1GroupsGroupIdMembershipGetRequest,
} from '@rbx/clients/groups';

// https://www.roblox.com/communities/1200769/Official-Group-of-Roblox#!/about
const officialGroupOfRobloxId = 1200769;

export class GroupsClient {
  private membershipApi: MembershipApi;

  constructor(basePath: string = getBEDEV1ServiceBasePath('groups')) {
    const defaultConfig = new Configuration({
      basePath,
      credentials: 'include',
    });

    this.membershipApi = new MembershipApi(defaultConfig);
  }

  async getGroupMembership(
    request: V1GroupsGroupIdMembershipGetRequest = { groupId: officialGroupOfRobloxId },
  ): Promise<RobloxGroupsApiGroupMembershipMetadataResponse> {
    const { raw } = await this.membershipApi.v1GroupsGroupIdMembershipGetRaw(request);

    return raw.json();
  }

  async isEmployee(): Promise<boolean> {
    // https://groups.roblox.com/v1/groups/1200769/membership?includeNotificationPreferences=false
    const membership = await this.getGroupMembership({ groupId: officialGroupOfRobloxId });
    const rank = membership?.userRole?.role?.rank ?? 0;
    return rank !== 0;
  }
}

const groupsClient = new GroupsClient();

export default groupsClient;
